import { __awaiter } from "tslib";
import { derived } from 'svelte/store';
import { cloudConnectionsStore, currentDatabase, getCloudConnectionsStore, openedConnections, openedSingleDatabaseConnections, } from '../stores';
import { apiCall, apiOn } from './api';
import _ from 'lodash';
export const possibleCloudConnectionSources = derived([currentDatabase, openedSingleDatabaseConnections, openedConnections], ([$currentDatabase, $openedSingleDatabaseConnections, $openedConnections]) => {
    var _a;
    const conids = new Set();
    if ((_a = $currentDatabase === null || $currentDatabase === void 0 ? void 0 : $currentDatabase.connection) === null || _a === void 0 ? void 0 : _a._id) {
        conids.add($currentDatabase.connection._id);
    }
    $openedSingleDatabaseConnections.forEach(x => conids.add(x));
    $openedConnections.forEach(x => conids.add(x));
    return Array.from(conids).filter(x => x === null || x === void 0 ? void 0 : x.startsWith('cloud://'));
});
function loadCloudConnection(conid) {
    return __awaiter(this, void 0, void 0, function* () {
        const conn = yield apiCall('connections/get', { conid });
        cloudConnectionsStore.update(store => (Object.assign(Object.assign({}, store), { [conid]: conn })));
    });
}
function ensureCloudConnectionsLoaded(...conids) {
    const conns = getCloudConnectionsStore();
    cloudConnectionsStore.update(store => _.pick(store, conids));
    conids.forEach(conid => {
        if (!conns[conid]) {
            loadCloudConnection(conid);
        }
    });
}
export function installCloudListeners() {
    possibleCloudConnectionSources.subscribe(conids => {
        ensureCloudConnectionsLoaded(...conids);
    });
    apiOn('cloud-content-updated', () => {
        const conids = Object.keys(getCloudConnectionsStore());
        cloudConnectionsStore.set({});
        for (const conn of conids) {
            loadCloudConnection(conn);
        }
    });
}
